/**
 * Why this firm, for this piece of work.
 *
 * A quiet two-column list rather than four more boxes, so it reads as
 * reasoning instead of another grid of claims. Titles are set in small caps
 * to keep them scannable at a glance.
 */
export const WhyTtite = ({ heading, lead, items, slug }) => (
  <section
    data-testid={`${slug}-why-ttite`}
    className="border-y border-border bg-[color:var(--tt-surface-2)] py-14 sm:py-20"
  >
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <h2 className="text-[27px] font-bold leading-[1.15] tracking-[-0.015em] text-foreground sm:text-[34px]">
            {heading}
          </h2>
          {lead ? (
            <p className="mt-4 max-w-[46ch] text-[15px] leading-relaxed text-muted-foreground">
              {lead}
            </p>
          ) : null}
        </div>

        <div className="lg:col-span-8">
          <dl className="grid grid-cols-1 gap-x-10 gap-y-8 sm:grid-cols-2">
            {items.map(({ icon: Icon, title, text }) => (
              <div
                key={title}
                data-testid={`${slug}-why-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <dt className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-[color:var(--tt-accent)] shadow-sm">
                    <Icon className="h-4 w-4" aria-hidden="true" />
                  </span>
                  <span className="text-[13px] font-bold uppercase leading-tight tracking-[0.08em] text-foreground">
                    {title}
                  </span>
                </dt>
                <dd className="mt-3 border-l border-border pl-4 text-sm leading-relaxed text-muted-foreground">
                  {text}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  </section>
);
